var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1423_14109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.79325 2.28516C1.49014 2.28516 1.19945 2.40556 0.985126 2.61989C0.770798 2.83422 0.650391 3.12491 0.650391 3.42801V14.2852C0.650391 14.5883 0.770798 14.879 0.985126 15.0933C1.19945 15.3076 1.49014 15.428 1.79325 15.428H14.3647C14.6678 15.428 14.9585 15.3076 15.1728 15.0933C15.3871 14.879 15.5075 14.5883 15.5075 14.2852V3.42801C15.5075 3.12491 15.3871 2.83422 15.1728 2.61989C14.9585 2.40556 14.6678 2.28516 14.3647 2.28516H12.079",
    stroke: "#6B6B6B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.650391 6.28516H15.5075",
    stroke: "#6B6B6B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 0.570312V3.99888",
    stroke: "#6B6B6B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0781 0.570312V3.99888",
    stroke: "#6B6B6B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 2.28516H9.79241",
    stroke: "#6B6B6B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.07812,
    y: 8.66797,
    width: 1.33333,
    height: 1.33333,
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.07812,
    y: 11.3359,
    width: 1.33333,
    height: 1.33333,
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.74609,
    y: 8.66797,
    width: 1.33333,
    height: 1.33333,
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.74609,
    y: 11.3359,
    width: 1.33333,
    height: 1.33333,
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.41016,
    y: 8.66797,
    width: 1.33333,
    height: 1.33333,
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.41016,
    y: 11.3359,
    width: 1.33333,
    height: 1.33333,
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.0781,
    y: 8.66797,
    width: 1.33333,
    height: 1.33333,
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7461,
    y: 8.66797,
    width: 1.33333,
    height: 1.33333,
    fill: "#6B6B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1423_14109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.f308b176c9dbee3193a002333fd66cd1.svg";
export { ForwardRef as ReactComponent };